<script setup>
import {ref} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import DatePicker from "vue2-datepicker";
import moment from "moment-timezone";

const {periods} = defineProps(['periods']);
const emit = defineEmits(["apply"]);

const showModal = ref(false);
const period = ref(periods[0]);
const customPeriod = ref([null, null]);

function apply() {
    showModal.value = false;
    emit('apply', [period.value, [
        parseInt(moment(customPeriod.value[0]).format('YYYY')),
        parseInt(moment(customPeriod.value[1]).format('YYYY'))
    ]]);
}

function open() {
    showModal.value = true;
}

function disabledDate(date) {
    return (new Date(date).getFullYear()) > new Date().getFullYear();
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <ul class="filters__list__choose" style="max-height: 300px; overflow-y: auto;">
            <li v-for="item in periods" :key="item.label">
                <div class="input-radio">
                    <input :id="`filter-company-${item.label}`" type="radio" v-model="period" :value="item">
                    <label :for="`filter-company-${item.label}`">{{item.label}}</label>
                </div>
            </li>
        </ul>

        <DatePicker
            v-if="period.value === 'custom'"
            v-model="customPeriod"
            range
            type="year"
            format="YYYY"
            :appendToBody="false"
            :disabled-date="disabledDate"
        />

        <div class="text-center mt-2">
            <PrimaryButton
                :disabled="period.value === 'custom' && (!customPeriod[0] || !customPeriod[1])"
                caption="Apply"
                @click="apply"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
